export default "__VITE_ASSET__D5ygu96a__"